/**
 * ! This file was generated by swagger-typescript-api. Do not change the file directly.
 */

import { PRODUCT_JOURNEY_GIRAR } from '../../../shared/utils/src/apis-paths'

import { type CommonCustomErrorResponse, type ProblemDetails, type WebV1TransparencyListData } from './data-contracts'
import { type RequestParams, HttpClient } from './http-client'

class Transparency extends HttpClient {
  private static httpInstance = new HttpClient(`${PRODUCT_JOURNEY_GIRAR}`)

  /**
   * No description
   *
   * @tags web
   * @name WebV1TransparencyList
   * @request GET:/api/web/v1/transparency
   * @secure
   * @response `200` `WebV1TransparencyListData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1TransparencyList(params: RequestParams = {}) {
    return this.httpInstance.get<WebV1TransparencyListData, CommonCustomErrorResponse | ProblemDetails>({
      url: `/api/web/v1/transparency`,
      ...params
    })
  }
}

export default Transparency
